import { takeEveryFsa } from "../operations";
import { blogActions } from "./actions";
import { makeAsyncApiCall } from "../common";
import { blogDetailApi, blogsApi } from "../../core/http/httpClient";

export function* blogSaga() {
  yield takeEveryFsa(blogActions.getBlogs.started, function* (action) {
    yield* makeAsyncApiCall(action, blogActions.getBlogs, blogsApi);
  });

  yield takeEveryFsa(blogActions.getBlogDetail.started, function* (action) {
    yield* makeAsyncApiCall(action, blogActions.getBlogDetail, blogDetailApi);
  });
}
